import { ActionButton } from '../../components/vertical-dot/popper';

interface GrantAcceptanceTemplateHeaderProps {
  actions: Record<string, any>[];
  tableActions: {
    id: string;
    action: string | React.ReactNode;
    onClick: (id: string, rowData?: any) => void;
  }[];
}

interface CellProps {
  row: any;
  cell: any;
}

export const GrantAcceptanceTemplateHeader = ({
  actions,
  tableActions,
}: GrantAcceptanceTemplateHeaderProps) => {
  const renderCell = ({ row, cell }: CellProps) => {
    return (
      <td>
        <ActionButton
          actions={tableActions}
          hideMenuOnActionClick
          id={row?.original?.templateId?.toString()}
          rowData={row?.original}
          counter={cell?.row?.index?.toString()}
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []),
    {
      Header: '',
      accessor: 'actions',
      width: 80,
      sortable: false,
      renderCell: true,
      Cell: renderCell,
    },
  ];

  return newActions;
};

export const GrantAcceptanceSubRowTemplateHeader = ({
  actions,
  tableActions,
}: GrantAcceptanceTemplateHeaderProps) => {
  const renderCell = ({ row, cell }: CellProps) => {
    return (
      <td className='subrow-header-cell'>
        <ActionButton
          actions={tableActions}
          hideMenuOnActionClick
          id={row?.original?.id?.toString()}
          rowData={row?.original}
          counter={cell?.row?.index?.toString()}
        />
      </td>
    );
  };
  return [
    ...(actions || []),
    {
      Header: '',
      accessor: 'actions',
      width: 80,
      renderCell: true,
      Cell: renderCell,
    },
  ];
};
